import { useState } from "react";
import { IStatus } from "../IWebsiteDataV3";
import { IStatusType, StatusPopoverPicker, statusTypeToIconMap } from "./StatusPopoverPicker";

export const HealthStatus: React.FC<{ statusType: IStatusType; status: IStatus; onChange: (status: IStatus) => void; }> = ({ status, onChange, statusType }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <i
                className={`fa ${statusTypeToIconMap[statusType]} ${status}`}
                onClick={() => {
                    setIsOpen(true);
                }}
            />
            <StatusPopoverPicker
                statusType={statusType}
                isOpen={isOpen}
                onStatusPicked={(status) => {
                    onChange(status);
                    setIsOpen(false);
                }}
            />
        </>
    )
}
